var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'sidebar-popover-mian',
    _vm.isWhole == true ? '' : 'sidebar-popover-mian2',
  ]},_vm._l((_vm.item.children),function(itemB,indexB){return _c('div',{key:indexB,staticClass:"popover-ul-mian"},[_c('ul',{staticClass:"sidebar-popover-ul"},[_c('div',{class:[
          'sidebar-popover-title',
          indexB == 0 ? 'popover-title-margin' : '',
        ]},[_vm._v("\n        "+_vm._s(itemB.meta && itemB.meta.title && itemB.meta.title != ""
            ? itemB.meta.title
            : "-")+"\n      ")]),(
          !(
            itemB.children &&
            Array.isArray(itemB.children) &&
            itemB.children.length > 0
          )
        )?_c('div',{class:[
          'sidebar-popover-li',
          _vm.activeMenu.indexOf('-' + itemB.id + '-') > -1
            ? 'popover-li-active'
            : '',
        ],on:{"click":function($event){$event.stopPropagation();return _vm.popoverClick([_vm.basePath, itemB.path], itemB.children, itemB)}}},[_vm._v("\n        "+_vm._s(itemB.meta && itemB.meta.title)+"\n      ")]):_vm._l((itemB.children),function(itemC,indexC){return [(
            itemC.children &&
            Array.isArray(itemC.children) &&
            itemC.children.length > 0
          )?[_c('el-submenu',{key:indexC,class:[
              'sidebar-popover-li',
              'sidebar-popover-li2',
              _vm.activeMenu.indexOf('-' + itemC.id + '-') > -1
                ? 'popover-li-active'
                : '',
            ],attrs:{"popper-append-to-body":false,"index":itemC.id.toString()}},[_c('template',{slot:"title"},[_c('span',[_vm._v("\n                "+_vm._s(itemC.meta && itemC.meta.title && itemC.meta.title))])]),_c('SidebarPopover',{attrs:{"basePath":itemC.path,"item":itemC,"activeId":_vm.activeId},on:{"close":_vm.closePopover}})],2)]:[_c('div',{key:indexC,class:[
              'sidebar-popover-li',
              _vm.activeMenu.indexOf('-' + itemC.id + '-') > -1
                ? 'popover-li-active'
                : '',
            ],on:{"click":function($event){$event.stopPropagation();return _vm.popoverClick(
                [_vm.basePath, itemB.path, itemC.path],
                indexC.children,
                itemC
              )}}},[_vm._v("\n            "+_vm._s(itemC.meta && itemC.meta.title)+"\n          ")])]]})],2)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }